import { moduleCategoryApi } from "../../api";

const ModuleCategoryService = {
  /**
   * 🔹 Obtiene las categorías de módulos en formato dropdown
   * Endpoint: GET /api/module-categories/dropdown
   */
  fetchDropdown: async () => {
    const response = await moduleCategoryApi.fetchCustom("/dropdown");
    return response.data; // ✅ Devuelve directamente la lista de categorías
  },
};

export default ModuleCategoryService;
